<!-- <div class="header"></div> -->
<div class="site-container">
    <app-ui-layout-header></app-ui-layout-header>
    <div class="information-content">
        <div class="information-head">Yarışma Ön Bilgilendirme</div>
        <ul>
            <li>Projeye kabul edilecek başvurularda yaş ve eğitim sınırı yoktur.</li>
            <li>Katılacak olan sanatçıların herhangi bir galeri ile sözleşmeli çalışmıyor olması gerekmektedir.</li>
            <li>Her sanatçı maksimum 5 eser ile katılım sağlayabilecektir.</li>
            <li>Sergiye yeni üretilmiş ve daha önce sergilenmemiş orijinal sanat eserleri ile proje başvuruları kabul
                edilecektir.</li>
            <li>Eserleri sergilenecek sanatçıların katılım sözleşmesini kabul etmeleri, eserlerinin sergilenmesine ve
                satılmasına izin vermeleri anlamına gelir.</li>
        </ul>
        <a class="direct-link" href="/basvuru-yonetmelik" target="_blank">Başvuru koşullarını
            ve yönetmeliğini okumak için tıklayın.</a>
        <br><br><br>
        <div class="information-head">Başvuru sırasında alınacak materyaller</div>
        <div class="information-sub-head">Video</div>
        <ul>
            <li><span>1 Adet </span> 180 derece ön/arka video görüntüsü yüklenmelidir.</li>
            <li>Video <span>4:3</span> oranında olmalıdır.</li>
            <li>Video maksimum <span>2 dk</span> olmalıdır.</li>
            <li>Video maksimum <span>50 MB</span> olmalıdır.</li>
            <li>Video sadece <span>.mp4</span> formatında kabul edilecektir.</li>
        </ul>
        <br>
        <div class="information-sub-head">Görsel </div>
        <ul>
            <li><span>1-5 adet</span> eser görseli yüklenmelidir.</li>
            <li>Her bir görsel <span>1000 px x 667 px</span> ölçülerinde olmalıdır.</li>
            <li>Her bir görsel <span>maksimum 10 MB</span> olmalıdır.</li>
            <li>Görseller sadece <span>.jpg ve .png</span> formatlarında kabul edilecektir.</li>
        </ul>
        <!-- <div class="form-checkbox-content">
            <label class="client-form-checkbox">
                <input aria-checked="false" (change)="handleSelectedBasvuru($event)" class="option-input checkbox"
                    name="checkbox-button" role="checkbox" tabindex="0" type="checkbox">
                <span><a href="/basvuru-yonetmelik" target="_blank">Başvuru Koşulları ve
                        Yarışma Yönetmeliği</a>'ni okudum ve onaylıyorum.</span>
            </label>
        </div>
        <div class="form-button">
            <a (click)="applyForm()">
                <span>Başvuru Formu için tıklayınız</span>
            </a>
        </div> -->
        <div class="input-error-message" *ngIf="showMeBasvuruTrue">
            <b>Başvurunuzu formu aşamasına geçebilmeniz için başvuru yönetmeliğini onaylamanız gerekmektedir.</b>
        </div>
    </div>
</div>
<!-- <div class="footer">
</div> -->